import reconitionIcon from "../assets/images/icon-brand-recognition.svg";
import customizeIcon from "../assets/images/icon-fully-customizable.svg";
import recordIcon from "../assets/images/icon-detailed-records.svg";
import { motion } from "motion/react";

const variants = {
	hidden: { opacity: 0, y: 40 },
	visible: (index) => ({
		opacity: 1,
		y: 0,
		transition: {
			delay: index * 0.2,
			type: "spring",
			duration: 1.3,
			bounce: 0,
		},
	}),
};

function Statistics() {
	const items = [
		{
			icon: reconitionIcon,
			alt: "brand recognition",
			className: "brand-recognition",
			title: "Brand Recognition",
			description:
				"Boost your brand recognition with each click. Generic links don’t mean a thing. Branded links help instil confidence in your content.",
		},
		{
			icon: recordIcon,
			alt: "detailed records",
			className: "detailed-records",
			title: "detailed-records",
			description:
				"Gain insights into who is clicking your links. Knowing when and where people engage with your content helps inform better decisions.",
		},
		{
			icon: customizeIcon,
			alt: "customizable",
			className: "customizable",
			title: "Fully Customizable",
			description:
				"Improve brand awareness and content discoverability through customizable links, supercharging audience engagement.",
		},
	];

	return (
		<div className="pros">
			<motion.h2
				initial={{ opacity: 0, y: -20 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true, amount: 0.3 }}
				transition={{ ease: "easeOut", duration: 0.5 }}
			>
				Advanced Statistics
			</motion.h2>

			<motion.p
				initial={{ opacity: 0, y: -20 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true }}
				transition={{ ease: "easeOut", duration: 0.5 }}
			>
				Track how your links are performing across the web with our advanced
				statistics dashboard.
			</motion.p>

			<div className="statistics">
				<div className="line-beneath"></div>
				{items.map((item, index) => (
					<motion.div
						className={`items ${item.className}`}
						key={item.className}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true, amount: 0.3 }}
						custom={index}
						variants={variants}
					>
						<div className="icon">
							<img src={item.icon} alt={item.alt} />
						</div>
						<h3>{item.title}</h3>
						<p>{item.description}</p>
					</motion.div>
				))}
			</div>
		</div>
	);
}

export default Statistics;
